import { render, staticRenderFns } from "./LinkCurved.vue?vue&type=template&id=5a4cc382&scoped=true&"
import script from "./LinkCurved.vue?vue&type=script&lang=js&"
export * from "./LinkCurved.vue?vue&type=script&lang=js&"
import style0 from "./LinkCurved.vue?vue&type=style&index=0&id=5a4cc382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4cc382",
  null
  
)

export default component.exports